import {Card} from 'platform/components';

import {useCallback} from 'react';

import {mergeAll} from 'ramda';

import i18n from '@dms/i18n';
import {testIds} from '@dms/routes';
import {DmsDataGrid, Section} from '@dms/shared';
import {useWarehouseParams} from '@dms/warehouse/shared-components';

import type {QueryFilterObject} from 'features/eag-grid';

export function Movements() {
  const params = useWarehouseParams();

  const queryModifier = useCallback(
    (filter: QueryFilterObject) => mergeAll([filter, {articleId: params.articleId}]),
    [params]
  );

  return (
    <Section isFullHeight>
      <Card title={i18n.t('entity.warehouse.labels.movements')} isFullHeight>
        <div css={{height: '100%'}}>
          <DmsDataGrid
            gridCode="stock-movements"
            queryModifier={queryModifier}
            data-testid={testIds.warehouse.articleDetailMovements('stock-movements')}
          />
        </div>
      </Card>
    </Section>
  );
}
